/************************************************************************************************/
//
// ! Eigentliche Skripte
//


var rwd_menu = 0;
var swipers = [];
var swipersI = [];
var swipersCnt = 0;
var cachedWidth = jQuery(window).width();

function resizetrigger() {


}

/************************************************************************************************/
//
// ! Scroll-Funktionen
//


function scrollToTop() {

    jQuery(window).scrollTop(jQuery(window).scrollTop() / 1.6);
    if (jQuery(window).scrollTop() > 5) {
        window.setTimeout(scrollToTop, 100);
    } else {
        jQuery(window).scrollTop(0);
    }
}

/************************************************************************************************/
//
// ! Ready
//

var init = function() {

    new Swiper(".lokSlider .swiper-container", {
        effect: "fade",
        autoplay: {
            duration: 2000
        }
    });

    console.log(jQuery(".simpleSwipe").length);

    jQuery(".simpleSwipe").each(function() {
        id = jQuery(this).attr("id");
        if (id) {
            swipers["swipe" + id] = new Swiper("#" + id, {
                autoHeight: true,
                navigation: {
                    nextEl: '.df-swiper-button-next',
                    prevEl: '.df-swiper-button-prev',
                },
                pagination: {
                    el: '.df-swiper-pagination'
                },
            });
            swipersI.push(id);
        }
    });

    new Swiper(".lokEventSlider .swiper-container", {
        slidesPerView: 1,
        autoplay: {
            duration: 2000
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 'auto',
            }
        },
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
        _pagination: {
            el: '.swiper-pager',
            type: 'custom',
            dynamicBullets: true
        },
    });

    jQuery(".halleSwitches div").click(function() {
        var name = jQuery(this).data("name");
        jQuery(".halleSingle").removeClass("show");
        jQuery("#halle" + name).addClass("show");
        jQuery(".halleSwitches div").removeClass("active");
        swipers["swipe" + jQuery(this).data("id")].update();
        jQuery(this).addClass("active");
    })

    jQuery(".seperator").click(function() {
        scrollTo = jQuery(this).offset().top + jQuery(this).height();
        jQuery('html, body').animate({
            scrollTop: scrollTo
        }, 'slow');
    });

    jQuery('[href^="#"]').click(function() {
        hash = jQuery(this).attr("href");
        scrollTo = jQuery(hash).offset().top - jQuery(hash).height();
        jQuery('html, body').animate({
            scrollTop: scrollTo
        }, 'slow');
    });

    if (jQuery("#dateFrom").length) {

        start = datepicker('#dateFrom', {
            id: 1,
            formatter: function(input, date, instance) {
                value = date.toLocaleDateString()
                input.value = value
            },
            startDay: 1, // Week starts on Monday
            customMonths: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
            customDays: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
            overlayButton: "Okay",
            overlayPlaceholder: 'Jahr (4-stellig)'

        });

        end = datepicker('#dateTo', {
            id: 1,
            formatter: function(input, date, instance) {
                value = date.toLocaleDateString()
                input.value = value
            },
            customMonths: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
            startDay: 1, // Week starts on Monday
            customDays: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
            overlayButton: "Okay",
            overlayPlaceholder: 'Jahr (4-stellig)'

        });

    }

    jQuery('[href$=".jpg"]').fancybox({
        afterClose: function(i) {
            console.info(i);
        },
    });

    jQuery('[href$=".png"]').fancybox({
        afterClose: function(i) {
            console.info(i);
        }
    });

    jQuery("#rwd_menu_link").click(function(e) {
        console.log(e);
        e.preventDefault();
        jQuery(this).toggleClass("open");
        jQuery("#mobile_menu").toggleClass("open");
    });

    jQuery("#contactFormSwitches h3").click(function() {
        jQuery("#contactForms").removeClass().addClass(jQuery(this).data("id"));
        jQuery(".contactForm").removeClass("show");
        jQuery("#" + jQuery(this).data("id")).addClass("show");
        jQuery("#contactFormSwitches h3").removeClass("active");
        jQuery(this).addClass("active");
    });

    window.setTimeout(function() {
        jQuery(".contactForm #contacForm").addClass("show");
    }, 500);

    if (self.location.hash != "") {
        hash = self.location.hash;
        scrollTo = jQuery(hash).offset().top - jQuery(hash).height() - jQuery("#headerSpacer").height();
        jQuery('html, body').animate({
            scrollTop: scrollTo
        }, 'slow');
    }

    var sMagic = new ScrollMagic.Controller();

    jQuery(".contactperson").each(function() {
        id = jQuery(this).attr("id");
        console.log(id);
        new ScrollMagic.Scene({
            triggerHook: "onEnter",
            triggerElement: "#" + id,
            reverse: false,
        }).setClassToggle("#" + id, "show").on('start', function(e) { console.log(e) }).addTo(sMagic);
    })

    jQuery("#eventSearch").submit(function() {
        jQuery('input[name="from"]').val(jQuery("#dateFrom").val());
        jQuery('input[name="to"]').val(jQuery("#dateTo").val());
    });

}

jQuery(document).ready(function() {

    jQuery("table").wrap('<div class="table" />');

    resizetrigger();

    init();


});

// Gutenberg




/**
 * Register the block.
 */